import { Pill, Sparkles, Scissors, Home, ShowerHead, Sprout, Leaf } from "lucide-react";

// Auto-assign a themed icon + accent colour to each store category.
const MAP = [
  { kw: ["supplement", "vitamin", "tablet", "capsule", "health", "nutrition"], Icon: Pill, color: "#3E8E4C" },
  { kw: ["skin", "face", "serum", "cream", "beauty", "cosmetic"], Icon: Sparkles, color: "#DB2777" },
  { kw: ["hair", "scalp"], Icon: Scissors, color: "#0D9488" },
  { kw: ["home", "house", "clean", "kitchen"], Icon: Home, color: "#2563EB" },
  { kw: ["personal", "body", "bath", "hygiene", "oral", "deo"], Icon: ShowerHead, color: "#7C3AED" },
  { kw: ["agri", "veterin", "farm", "crop", "cattle", "plant"], Icon: Sprout, color: "#65A30D" },
];

export function categoryVisual(name = "") {
  const n = String(name).toLowerCase();
  for (const m of MAP) if (m.kw.some((k) => n.includes(k))) return { Icon: m.Icon, color: m.color };
  return { Icon: Leaf, color: "#3E8E4C" };
}
